import ForgetPassword from "./ForgotPassword";
export default ForgetPassword;
